import React from 'react';
import { Badge } from '@/components/ui/badge';
import { REQUEST_STATUS } from '@/utils/constants.js';
import { Clock, CheckCircle2, AlertCircle, XCircle, Loader2 } from 'lucide-react';

const RequestStatusBadge = ({ status }) => {
  const getStatusConfig = () => {
    switch (status) {
      case REQUEST_STATUS.PENDING:
        return {
          variant: 'secondary',
          icon: Clock,
          label: 'Pending'
        };
      case REQUEST_STATUS.ACCEPTED:
        return {
          variant: 'default',
          icon: AlertCircle,
          label: 'Accepted'
        };
      case REQUEST_STATUS.IN_PROGRESS:
        return {
          variant: 'default',
          icon: Loader2,
          label: 'In Progress'
        };
      case REQUEST_STATUS.COMPLETED:
        return {
          variant: 'default',
          icon: CheckCircle2,
          label: 'Completed',
          className: 'bg-green-600 hover:bg-green-700'
        };
      case REQUEST_STATUS.CANCELLED:
        return {
          variant: 'destructive',
          icon: XCircle,
          label: 'Cancelled'
        };
      default:
        return {
          variant: 'secondary',
          icon: Clock,
          label: status
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  return (
    <Badge variant={config.variant} className={`${config.className || ''} transition-all duration-200`}>
      <Icon className="w-3 h-3 mr-1" />
      {config.label}
    </Badge>
  );
};

export default RequestStatusBadge;